/// <amd-module name="Core/Medius.Core.Web/Scripts/Bifrost/communication"/>

export function notifyOnLoad(){
    window.top.postMessage({ version: 1, origin: "Midgard", type: "loaded", data: {
        application: "APA"
    } }, '*');
}

export function notifyOnHashChange(event: any) {
    window.top.postMessage({ version: 1, origin: "Midgard", type: "hashchange", data: {
        url: event.newURL
    } }, '*');

    const urlMappings = [
        // route admin pages only to legacyInbox after admin pages AP fix
        { pattern: "SupplierInvoicesInboxLegacy#/Administration", app: "ApaManagement" },
        { pattern: "SupplierInvoicesInboxLegacy#/configuration", app: "ApaManagement" },
        { pattern: "SupplierInvoicesInboxLegacy#/Reports", app: "ApaReporting" },
        { pattern: "SupplierInvoicesInboxLegacy#/Dashboard", app: "ApaDashboard" },
        { pattern: "SupplierInvoicesInbox#/Tasks", app: "ApaInbox" },
        { pattern: "SupplierInvoicesInboxLegacy#", app: "ApaInboxLegacy"}
    ];

    function shouldChangeBifrostUrl(newUrl: string, oldUrl: string): boolean {
        const oldUrlObj = new URL(oldUrl);
        const newUrlObj = new URL(newUrl);
        return oldUrlObj.pathname !== newUrlObj.pathname || oldUrlObj.hash !== newUrlObj.hash;
    }

    function getDeepLink(url: string): string {
        for (const mapping of urlMappings) {
            if (url.includes(mapping.pattern)) {
            const patternIndex = url.indexOf(mapping.pattern);
            const afterPattern = url.substring(patternIndex + mapping.pattern.length);
            return afterPattern || "";
            }
        }
        return "";
    }

    function getTargetApp(url: string): string {
        const match = urlMappings.find(mapping => url.includes(mapping.pattern));
        return match ? match.app : "";
    }

    if (shouldChangeBifrostUrl(event.newURL, event.oldURL)) {
        const targetApp = getTargetApp(event.newURL);        
        const deepLink = getDeepLink(event.newURL);
        notifyNavigateTo(event.oldURL, targetApp, deepLink, event.newURL);
    }
        
}

export function notifyVersion(version: string) {
    window.top.postMessage({ version: 1, origin: "Midgard", type: "version", data: {
        version
    } }, '*');
}

export function notifyExportsChange(exportData: any) {
    window.top.postMessage({ version: 1, origin: "Midgard", type: "exportchange", data: {
        exports: exportData
    } }, '*');
}

export function notifyExportsModalShown() {
    window.top.postMessage({ version: 1, origin: "Midgard", type: "exports-modal-shown", data: {} }, '*');
}

export function notifyShowNotification(kind: 'success' | 'info' | 'error', title?: string | null, message?: string | null) {
    window.top.postMessage({ version: 1, origin: "Midgard", type: "notification-shown", data: {
        kind,
        title: title || null,
        message: message || null
    } }, '*');
}

export function notifyNavigateTo(currentUrl: string, targetApp: string, deepLink: string, newURL: string) {
    window.top.postMessage({ version: 1, origin: "Midgard", type: "navigate-to", data: {
        "currentUrl": currentUrl,
        "targetUrl": newURL,
        "targetApp": targetApp,                
        "deepLink": deepLink
    } }, '*');
}
